<template>
  <div class="normalpaper">
    <div class="header">
      <div class="contain_main">
        <div class="logo">
          <img src="@/assets/header/logo.png" alt>
        </div>
        <div>
          <div class="button" @click="exceladd=true">Excel导入</div>
          <div class="button" @click="$router.go(-1)">返回</div>
        </div>
      </div>
    </div>
    <div style="height:0.8rem"></div>
    <div class="contain_main content">
      <div class="left">
        <div @click="make(1)">单选题</div>
        <div @click="make(2)">多选题</div>
        <div @click="make(4)">填空题</div>
        <div @click="make(3)">判断题</div>
        <div @click="make(5)">主观题</div>
        <!-- <div @click="make(0)">段落说明</div> -->
      </div>
      <div class="right">
        <makeissue
          v-for="(item,index) in list"
          :key="item.questionid"
          :order="(index+1)"
          @exit="exit"
          @complated="edit"
          @delitem="delitem"
          @moveupitem="moveupitem"
          @movedownitem="movedownitem"
          @isedit="isedit"
          :message="item"
        />
      </div>
    </div>
    <exceladd v-if="exceladd" @sure="sure" @close="close"></exceladd>
  </div>
</template>
<script>
import makeissue from "../../components/makeissue";
import exceladd from "../../components/exceladd";
export default {
  data() {
    return {
      list: [],
      exceladd: false
    };
  },
  mounted() {
    // if(window.localStorage.getItem('normalpaperlist')){
    //     this.list=JSON.parse(window.localStorage.getItem('normalpaperlist'))
    // }
  },
  components: {
    makeissue,
    exceladd
  },
  methods: {
    close() {
      this.exceladd = false;
    },
    isedit(index, isedit) {
      this.list = this.list.map(item => {
        item.hasedit = true;
        return item;
      });
      this.list[index].isedit = true;
    },
    checkisedit() {
      if (this.list.some(item => item.isedit)) {
        this.errorPlus("有题目在编辑状态,请完成编辑后操作!");
        return true;
      } else {
        return false;
      }
    },
    make(data) {
      if (this.checkisedit()) return;
      this.list.push({
        questiontype: data,
        isedit: true
      });
      this.list = this.list.map(item => {
        item.hasedit = true;
        return item;
      });
      this.$nextTick(function() {
        window.scrollTo(0, document.documentElement.clientHeight + 600);
      });
    },
    exit(index) {
      this.list = this.list.map(item => {
        delete item.hasedit;
        delete item.isedit
        return item;
      });
      if (!this.list[index].questionid) {
        this.list.splice(index, 1);
      }
    },
    sure(data) {
      this.list = this.list.concat(data);
      this.list = this.list.map(item => {
        delete item.qbtitle;
        return item;
      });
    },
    edit(data, index) {
      this.list = this.list.map(item => {
        delete item.hasedit;
        delete item.isedit
        return item;
      });
      this.list[index - 1] = data;
    },
    delitem(data) {
      this.list.splice(data, 1);
    },
    moveupitem(data) {
      if (data == 0) {
        this.errorPlus("已经在最顶部,无法上移!");
        return;
      }
      this.list[data - 1] = this.list.splice(data, 1, this.list[data - 1])[0];
    },
    movedownitem(data) {
      if (data == this.list.length - 1) {
        this.errorPlus("已经在最底部,无法下移!");
        return;
      }
      this.$set(
        this.list,
        data,
        this.list.splice(data + 1, 1, this.list[data])[0]
      );
    }
  }
};
</script>
<style lang="css" scoped>
.normalpaper {
  position: absolute;
  width: 100%;
  height: 100%;
}
.header {
  height: 0.8rem;
  text-align: left;
  border-bottom: #e8e9ee 1px solid;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: #fff;
}
.header .contain_main {
  display: flex;
  justify-content: space-between;
  line-height: 0.8rem;
}
.logo {
  width: 1.84rem;
  height: 0.4rem;
  line-height: 0.4rem;
  margin-top: 0.2rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  margin: 0 0.15rem;
}
.content {
  /* display: flex;
  justify-content: space-between; */
}
.left {
  width: 1rem;
  position: fixed;
  top: 0.8rem;
}
.right {
  width: 9rem;
  height: 100%;
  float: right;
}
.left > div {
  height: 0.3rem;
  width: 1rem;
  margin: 0.1rem auto;
  color: #7b8b9f;
  line-height: 0.3rem;
  border-radius: 0.15rem;
  font-size: 0.16rem;
  background: #e9effa62;
  cursor: pointer;
}
.left > div:hover {
  background: #ccddff;
  color: #474dff;
}
</style>


// WEBPACK FOOTER //
// src/pages/issue/issueadd.vue